import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import UnAuth from '@/views/Main/UnAuth.vue'
import Auth from '@/views/Main/Auth.vue'

import useIsUserAuth from '@/hooks/useIsUserAuth'

export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const isAuthUser = computed<boolean>(()=> useIsUserAuth())


return (_ctx: any,_cache: any) => {
  return (isAuthUser.value)
    ? (_openBlock(), _createBlock(Auth, { key: 0 }))
    : (_openBlock(), _createBlock(UnAuth, { key: 1 }))
}
}

})